
import React from 'react';
import { Link } from 'react-router-dom';

interface PopularPostProps {
  post: {
    id: number;
    title: string;
    slug: string;
    date: string;
    image: string;
  };
  onClick?: () => void;
}

const PopularPost: React.FC<PopularPostProps> = ({ post, onClick }) => {
  return (
    <div className="flex gap-3">
      <div className="w-16 h-16 flex-shrink-0 overflow-hidden rounded">
        <img 
          src={post.image}
          alt={post.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div>
        <h4 className="text-sm font-medium">
          <Link 
            to={`/blog/${post.slug}`} 
            className="hover:text-itmgmt-medium-blue"
            onClick={onClick}
          >
            {post.title}
          </Link>
        </h4>
        <p className="text-xs text-gray-500">{post.date}</p>
      </div>
    </div>
  );
};

export default PopularPost;
